import React from 'react'
import { reduxForm } from 'redux-form'
import {
  makeStyles,
  Backdrop,
  CircularProgress,
  // Input,
  styled
} from '@material-ui/core'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import moment from 'moment'

import { showAlertMessage } from '../store/alert/actions'
import { getChildrenRSPA } from '../store/classrooms/actions'
import { getPickupAuthorizations } from '../store/pickup/actions'
import { createPickupQueueRSPA } from '../store/pickup_queue/actions'

import { relationOptions } from '../utils/constants'
import UserAvatar from '../components/shared/UserAvatar'
import Button from '../components/button/Button'
import CustomTable from '../components/table/CustomTable'
import InputSelect from '../components/select/InputSelect'
import StyledSVG from '../components/shared/StyledSVG'
import emptyAvatar from '../assets/icons/empty-avatar-icon.svg'
import yellowWarningSVG from '../assets/icons/rounded-yellow-warning.svg'
import crossAddSVG from '../assets/icons/cross-add-icon.svg'
// import searchIcon from '../assets/icons/search-icon.svg'
import characterMagnifyingGlass from '../assets/icons/ilustration-character-with-magnifying-glass.svg'
import createQueueSuccessSVG from '../assets/icons/success-pickup-backdrop.svg'
import Modal from '../components/modal/Modal'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '64px 32px',
    fontFamily: 'Montserrat, Source Sans Pro',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    height: '100%',
    width: '96%'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    '& .title': {
      display: 'flex',
      alignItems: 'center',
      columnGap: 8,
      '& path': {
        stroke: '#386093'
      },
      '& h1': {
        margin: 0,
        fontSize: 32,
        fontWeight: 700,
        color: '#386093'
      }
    }
  },
  authorize_pickup_btn: {
    backgroundColor: '#92CB5A',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#92CB5A'
    },
    color: '#FFFFFF',
    fontSize: '16px',
    fontWeight: 700,
    textTransform: 'capitalize',
    lineHeight: '100%',
    height: 48,
    width: 300
  },
  go_back_btn: {
    backgroundColor: '#F4A87C',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#F4A87C'
    },
    fontSize: '16px',
    fontWeight: 700,
    textTransform: 'capitalize',
    lineHeight: '100%',
    height: 48,
    width: 144
  },
  cross_add_wrapper: {
    width: 30,
    height: 30,
    borderRadius: 30,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #264468',
    '& path': {
      fill: '#264468'
    }
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '& h1': {
      margin: 0,
      fontSize: 32,
      fontWeight: 700,
      color: '#386093'
    }
  },
  search_component: {
    width: '325px',
    height: 40,
    padding: '8px 12px',
    borderRadius: '8px',
    border: '1px solid #D2D5D8',
    '& input': {
      padding: 0
    }
  },
  inputs_wrapper: {
    display: 'flex',
    columnGap: 32,
    alignItems: 'flex-start'
  },
  responsible_input_wrapper: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8,
    '& p': {
      margin: 0,
      fontWeight: 600,
      fontSize: 12
    }
  },
  input_wrapper: {
    width: 325
  },
  avatar_wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    '& p': {
      fontWeight: 500,
      fontSize: 16,
      color: '#555555'
    }
  },
  table_root: {
    marginTop: 32
  },
  backdrop_icon_wrapper: {
    width: 400,
    height: 320,
    borderRadius: 24,
    backgroundColor: '#386093',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '32px 56px 48px 48px',
    rowGap: 16,
    '& .title': {
      margin: 0,
      color: '#F1F3F4',
      fontWeight: 600,
      fontSize: 24
    },
    '& .subtitle': {
      margin: 0,
      color: '#FFFFFF',
      fontWeight: 400,
      fontSize: 14
    }
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1
  },
  without_authorization_fallback: {
    marginTop: 52,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '& .fallback_description': {
      '& h1': {
        fontWeight: 600,
        fontSize: 20,
        margin: 0,
        marginBottom: 8
      },
      '& p': {
        color: '#7B7B7B',
        fontWeight: 500,
        fontSize: 12,
        margin: 0
      }
    }
  },
  img_wrapper: {
    width: 240,
    height: 270
  },
  authorization_confirm_modal: {
    padding: 56,
    width: 500,
    height: 600,
    fontFamily: 'Montserrat, Source Sans Pro'
  },
  authorization_confirm_modal_header: {
    marginBottom: 40,
    display: 'flex',
    flexDirection: 'column',
    rowGap: 16,
    alignItems: 'flex-start',
    textAlign: 'start',
    '& h1': {
      margin: 0,
      color: '#386093',
      fontWeight: 600,
      fontSize: 24
    },
    '& p': {
      margin: 0,
      color: '#9B9B9B',
      fontWeight: 500,
      fontSize: 16
    }
  },
  authorization_users_wrapper: {
    marginBottom: 16,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    rowGap: 16
  },
  authorization_user: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 16
  },
  user_identification: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    rowGap: 4,
    '& h1': {
      margin: 0,
      fontWeight: 600,
      fontSize: 18
    },
    '& p': {
      margin: 0,
      color: '#9B9B9B',
      fontWeight: 400,
      fontSize: 16
    }
  },
  authorization_data_wrapper: {
    marginBottom: 24,
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8
  },
  authorization_data: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 4,
    '& p': {
      margin: 0,
      fontWeight: 500,
      fontSize: 16
    },
    '& .label': {
      color: '#9B9B9B'
    }
  },
  modal_warning: {
    marginBottom: 40,
    display: 'flex',
    alignItems: 'center',
    columnGap: 12,
    width: '100%',
    backgroundColor: '#FEF7DD',
    borderRadius: 16,
    padding: '8px 32px 8px 8px',
    '& p': {
      margin: 0,
      fontSize: 14,
      fontWeight: 400,
      textAlign: 'start'
    },
    '& span': {
      fontWeight: 600
    }
  },
  remove_doorman_btns_wrapper: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 16
  },
  filled_btn: {
    padding: 16,
    gap: 10,
    borderRadius: 8,
    width: 190,
    height: 48,
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none !important'
  },
  remove_doorman_cancel: {
    backgroundColor: '#EF7C8F',
    color: '#FFFF',
    '&:hover': {
      backgroundColor: '#EF7C8F'
    }
  },
  remove_doorman_btn: {
    backgroundColor: '#386093',
    color: '#FFFF',
    '&:hover': {
      backgroundColor: '#386093'
    }
  }
}))

const UserPhoto = styled('img')(({ theme, bgImg }) => {
  return {
    minWidth: 56,
    height: 56,
    borderRadius: 16,
    backgroundSize: 'cover',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
})

const PickupManualPage = ({
  authorizations,
  getChildrenRSPA,
  getPickupAuthorizations,
  createPickupQueueRSPA,
  schoolId,
  currentUser,
  alert
}) => {
  const classes = useStyles()
  const history = useHistory()
  const authorizationType = {
    permanent: 'Autorização fixa',
    temporary: 'Somente hoje'
  }
  const [selectedChild, setSelectedChild] = React.useState([])
  // const [responsibleName, setResponsibleName] = React.useState('')
  const [pickupConfirmationModal, setPickupConfirmationModal] = React.useState({
    id: null,
    open: false,
    data: {}
  })

  const [searchParams, setSearchParams] = React.useState({})
  const [backdrop, setBackdrop] = React.useState({ open: false, svg: null })

  const columns = [
    {
      key: 'name',
      name: 'Reponsável',
      width: '25%',
      render: row => {
        const parentData = {
          ...(row?.pickup_authorization?.user_id
            ? { name: row?.user?.name, photo: row?.user?.avatar_url }
            : { name: row?.name, photo: row?.photo_url })
        }
        return (
          <div className={classes.avatar_wrapper}>
            <UserAvatar
              avatarStyle={{
                width: 40,
                height: 40
              }}
              withoutUserName
              userName={parentData.name}
              avatarUrl={parentData.photo}
            />
            <p>{parentData.name}</p>
          </div>
        )
      }
    },
    {
      key: 'relationship_type',
      name: 'Vínculo',
      width: '12%',
      render: row => {
        return (
          <p>
            {
              relationOptions.find(item => item.value === row.relationship_type)
                .label
            }
          </p>
        )
      }
    },
    {
      key: 'taxpayer_number',
      name: 'CPF',
      width: '12%',
      render: row => {
        return <p>{row?.taxpayer_number}</p>
      }
    },
    {
      key: 'phone',
      name: 'Telefone',
      width: '12%',
      render: row => {
        return <p>{row?.phone}</p>
      }
    },
    {
      key: 'vehicle_plate',
      name: 'Placa',
      width: '10%',
      render: row => {
        return <p>{row?.vehicle_plate?.toUpperCase()}</p>
      }
    },
    {
      key: 'authorize_action',
      name: '',
      width: '16%',
      render: row => {
        const resposible_type_by_user = row?.user?.child_parents?.find(
          cp => +cp.child_id === +selectedChild?.[0]?.id
        )?.relationship_type
        const responsible_name = row?.user_id ? row.user?.name : row.name
        const responsible_photo = row?.user_id
          ? row.user?.avatar_url
          : row.photo_url

        const responsible_type = row?.user_id
          ? relationOptions.find(
              relationship => relationship.value === resposible_type_by_user
            )?.label
          : relationOptions.find(
              relationship => relationship.value === row?.relationship_type
            )?.label
        return (
          <Button
            type='button'
            onclick={() =>
              setPickupConfirmationModal({
                id: row.id,
                open: true,
                data: {
                  responsible_name,
                  responsible_photo,
                  responsible_type,
                  authorization_data: {
                    type: authorizationType[row.pickup_type],
                    vehicle_plate: row?.vehicle_plate?.toUpperCase()
                  }
                }
              })
            }
            className={classes.authorize_pickup_btn}
          >
            Autorizar saída
          </Button>
        )
      }
    }
  ]

  React.useEffect(
    () => {
      if (selectedChild.length > 0) {
        const params = {
          'q[children_id_eq]': selectedChild?.[0]?.id,
          'q[pickup_type_eq]': 1,
          include:
            'user.child_parents,authorized_by,pickup_authorization_children.child.classrooms,school'
        }
        setSearchParams(params)
        getPickupAuthorizations({
          params
        })
      }
    },
    [selectedChild]
  )

  const handleCreatePickupQueue = authorization => {
    setBackdrop(prev => ({ ...prev, open: true }))
    createPickupQueueRSPA({
      pickup_authorization_id: authorization.id,
      pickup_queue_children_attributes: [{ child_id: selectedChild?.[0]?.id }],
      status: 'finished',
      picked_at: moment(new Date()).format('DD/MM/YYYY HH:mm'),
      approved_by_id: currentUser.id
    })
      .then(res => {
        setBackdrop(prev => ({ ...prev, svg: createQueueSuccessSVG }))
      })
      .catch(err => {
        console.error(err)
        setBackdrop({ svg: null, open: false })
        alert('Erro ao concluir a retirada.', 'error')
      })
  }

  // const handleChangeResponsibleName = event => {
  //   const name = event.target.value
  //   setResponsibleName(name)
  //   const params = {
  //     'q[children_id_eq]': selectedChild?.[0]?.id,
  //     'q[name_cont]': name,
  //     'q[pickup_type_eq]': 1,
  //     'q[m]': 'and'
  //   }
  //   setSearchParams(params)
  //   getPickupAuthorizations({
  //     params
  //   })
  // }

  const handleClosepPickupConfirmationModal = () => {
    setPickupConfirmationModal({ id: null, open: false, data: {} })
  }

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className='title'>
          <div className={classes.cross_add_wrapper}>
            <StyledSVG src={crossAddSVG} height={12} width={12} />
          </div>
          <h1>Retirada Manual</h1>
        </div>
        <Button
          type='button'
          onclick={() => history.goBack()}
          className={classes.go_back_btn}
        >
          Voltar
        </Button>
      </div>
      <p className='subtitle'>
        Realize a retirada manualmente pesquisando pelo nome do aluno.
      </p>
      <div className={classes.inputs_wrapper}>
        <InputSelect
          wrapperClass={classes.input_wrapper}
          fetchItems={getChildrenRSPA}
          selectedItems={selectedChild}
          setSelectedItems={setSelectedChild}
          attributesFromItem={['avatar_url', 'name']}
          placeholder={'Digite o nome do aluno'}
          label={'Buscar aluno'}
          params={{
            'page[size]': 7,
            'q[classroom_child_classroom_year_lteq]':
              new Date().getFullYear() + 1,
            'q[classroom_child_classroom_year_gteq]': new Date().getFullYear()
          }}
        />
        {/* <div className={classes.responsible_input_wrapper}>
          <p>Responsável</p>
          <Input
            disableUnderline
            value={responsibleName}
            className={classes.search_component}
            placeholder='Busque pelo nome do responsável'
            onChange={e => handleChangeResponsibleName(e)}
            endAdornment={<StyledSVG src={searchIcon} width={18} height={18} />}
          />
        </div> */}
      </div>
      {selectedChild?.[0] ? (
        <CustomTable
          classRoot={classes.table_root}
          columns={columns}
          from={'authorizations'}
          noDataAlert={
            'Ninguém além dos responsáveis legais e com acesso ao aplicativo está autorizado a retirar a criança.'
          }
          data={authorizations.items}
          fetchItems={getPickupAuthorizations}
          params={{
            ...searchParams,
            include:
              'user.child_parents,authorized_by,pickup_authorization_children.child.classrooms,school'
          }}
          isFetching={authorizations.isFetching}
          pagination={authorizations.pagination}
          columnsPointer={[0]}
          border={'none'}
          headCellRadius
          headColor={'rgba(173, 184, 204, 0.3)'}
        />
      ) : (
        <div className={classes.without_authorization_fallback}>
          <img className={classes.img_wrapper} src={characterMagnifyingGlass} />
          <div className='fallback_description'>
            <h1>Configure os filtros para começar</h1>
            <p>Selecione o aluno ou o responsável para iniciar a busca</p>
          </div>
        </div>
      )}
      <Backdrop
        onClick={() => setBackdrop(prev => ({ svg: null, open: false }))}
        className={classes.backdrop}
        open={backdrop.open}
      >
        {backdrop.svg ? (
          <div className={classes.backdrop_icon_wrapper}>
            <StyledSVG width={120} height={110} src={createQueueSuccessSVG} />
            <h1 className='title'>Retirada Concluída</h1>
            <p className='subtitle'>
              {selectedChild?.[0]?.name} já está com o responsável. Tenha um
              ótimo dia!
            </p>
          </div>
        ) : (
          <CircularProgress />
        )}
      </Backdrop>
      <Modal
        open={pickupConfirmationModal.open}
        handleClose={handleClosepPickupConfirmationModal}
        disablePadding
      >
        <div className={classes.authorization_confirm_modal}>
          <div className={classes.authorization_confirm_modal_header}>
            <h1>Confirmar autorização de saída</h1>
            <p>
              Você está prestes a autorizar a retidada do aluno por este
              responsável
            </p>
          </div>
          <div className={classes.authorization_users_wrapper}>
            <div className={classes.authorization_user}>
              <UserPhoto
                key={pickupConfirmationModal.id}
                src={
                  pickupConfirmationModal.data?.responsible_photo || emptyAvatar
                }
              />
              <div className={classes.user_identification}>
                <h1>{pickupConfirmationModal.data?.responsible_name}</h1>
                <p>{`Responsável${
                  pickupConfirmationModal.data?.responsible_type
                    ? ` - ${pickupConfirmationModal.data?.responsible_type}`
                    : ''
                }`}</p>
              </div>
            </div>
            <div className={classes.authorization_user}>
              <UserPhoto
                key={selectedChild?.[0]?.id}
                src={selectedChild?.[0]?.avatar_url || emptyAvatar}
              />
              <div className={classes.user_identification}>
                <h1>{selectedChild?.[0]?.name}</h1>
                <p>Aluno</p>
              </div>
            </div>
          </div>
          <div className={classes.authorization_data_wrapper}>
            {[
              { label: 'Tipo de autorização:', value: 'type' },
              { label: 'Placa do veículo:', value: 'vehicle_plate' }
            ].map(item => {
              const hasAttribute = !!pickupConfirmationModal.data
                ?.authorization_data?.[item.value]
              if (hasAttribute) {
                return (
                  <div key={item.value} className={classes.authorization_data}>
                    <p className='label'>{item.label}</p>
                    <p>
                      {
                        pickupConfirmationModal.data?.authorization_data?.[
                          item.value
                        ]
                      }
                    </p>
                  </div>
                )
              }
            })}
          </div>
          <div className={classes.modal_warning}>
            <StyledSVG src={yellowWarningSVG} width={20} height={20} />
            <p>
              <span>Ao confirmar</span>, a saída ficará registrada no sistema e
              disponível para auditoria.
            </p>
          </div>
          <div className={classes.remove_doorman_btns_wrapper}>
            <Button
              onClick={handleClosepPickupConfirmationModal}
              className={` ${classes.filled_btn} ${
                classes.remove_doorman_cancel
              }`}
              type='button'
            >
              Cancelar
            </Button>
            <Button
              className={`${classes.filled_btn} ${classes.remove_doorman_btn}`}
              type='button'
              onClick={() =>
                handleCreatePickupQueue(pickupConfirmationModal.id)
              }
            >
              Autorizar saída
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}
const mapStateToProps = (state, props) => ({
  authorizations: state.authorizations,
  schoolId: state.school?.currentSchool?.school_id,
  currentUser: state?.auth?.user?.data
})

const mapDispatchToProps = dispatch => ({
  getChildrenRSPA: data => dispatch(getChildrenRSPA.request(data)),
  getPickupAuthorizations: data => dispatch(getPickupAuthorizations(data)),
  createPickupQueueRSPA: data => dispatch(createPickupQueueRSPA.request(data)),
  alert: (message, type) =>
    dispatch(
      showAlertMessage({
        message: message,
        severity: type
      })
    )
})

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'ManualAuthorizationPage'
    // enableReinitialize: true,
    // touchOnChange: true,
    // touchOnBlur: true,
  })(PickupManualPage)
)
